export { default as fetchRecentSearches } from './fetchRecentSearches';
export { default as fetchSuggestedVehicles } from '~/services/common/fetchSuggestedVehicles';
